import { TopLevelPermission } from "@outverse-video/outverse-api-client-lib/src/api";
import { derived, writable } from "svelte/store";
import api from "$utils/api";

export interface PermissionState {
  permissions: TopLevelPermission[];
  flags: string[];
}

export const permissions = writable<PermissionState>(
  {
    permissions: [],
    flags: [],
  },
  (set) => {
    api.apiUsersPermissions().then((resp) =>
      set({
        permissions: resp.data.permissions || [],
        flags: resp.data.flags || [],
      })
    );
  }
);

export const canCreateCommunity = derived(permissions, ($permissions) => {
  return $permissions.permissions.some(
    (permission) => permission === TopLevelPermission.AddCommunity
  );
});
